import { LOCALE_DEFINITIONS } from '@wework/universal-locale-utils';
import { onContentLoaded } from './on_content_loaded';
import { varsFromServer } from './client_side_injection_vars';

const LANGUAGE_INPUT_ID = 'languageInput';
const DROPDOWN_CONTAINER_CLASS = '.page-footer__dropdown-container';
const DROPDOWN_OPTION_CLASS = '.page-footer__dropdown-option';
const DROPDOWN_ARROW_CLASS = '.page-footer__dropdown-arrow';
const DROPDOWN_OPEN_CLASS = 'page-footer__dropdown-open';

function getLocaleLabel(locale = 'en-US') {
  return LOCALE_DEFINITIONS.find(definition => definition.code === locale).label;
}

onContentLoaded(() => {
  const { locale: currentLocale } = varsFromServer;
  const languageInput = document.getElementById(LANGUAGE_INPUT_ID);

  if (languageInput) {
    const localeLabel = getLocaleLabel(currentLocale);
    languageInput.value = localeLabel;
  }

  const languageDropdown = document.querySelector(DROPDOWN_CONTAINER_CLASS);
  if (languageDropdown) {
    const languageList = document.querySelector(DROPDOWN_OPTION_CLASS);
    const languageLinks = languageList.querySelectorAll('li a');
    const dropdownArrow = document.querySelector(DROPDOWN_ARROW_CLASS);

    Array.from(languageLinks).forEach(link => {
      link.addEventListener('click', () => {
        languageInput.value = link.innerText;
        link.href += window.location.search; // eslint-disable-line no-param-reassign
        languageDropdown.classList.remove(DROPDOWN_OPEN_CLASS);
      });
      link.addEventListener('mousedown', e => {
        e.preventDefault();
      });
    });

    languageInput.addEventListener('blur', () => {
      languageDropdown.classList.remove(DROPDOWN_OPEN_CLASS);
      dropdownArrow.classList.remove('triangle-icon--blue', 'triangle-icon--up');
    });

    languageInput.addEventListener('focus', () => {
      dropdownArrow.classList.add('triangle-icon--blue');
    });

    languageInput.addEventListener('click', () => {
      languageDropdown.classList.toggle(DROPDOWN_OPEN_CLASS);
      dropdownArrow.classList.toggle('triangle-icon--up');
    });
  }
});
